import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../utils-consultaSeguimento'
import { ConsultaSeguimentoPergunta20Model } from './model-consultaSeguimentoPergunta20'
import { hasPergunta20ExemplosAnySim, isPergunta20ExemplosAllNao } from './utils-consultaSeguimentoPergunta20'

export const validatorConsultaSeguimentoPergunta20 = createValidator<ConsultaSeguimentoPergunta20Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_20_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta20Model, errors: ErrorObject<ConsultaSeguimentoPergunta20Model>) => {
    if (values?.PERGUNTA_20_HEADER === SimNaoEnum.SIM) {
      errors.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR = required(values?.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR)
    }

    if (
      values?.PERGUNTA_20_HEADER === SimNaoEnum.NAO ||
      values?.PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR === SimNaoEnum.NAO
    ) {
      const isExemplosAllNao = isPergunta20ExemplosAllNao(values)
      const hasExemplosAnySim = hasPergunta20ExemplosAnySim(values)

      if (!(isExemplosAllNao || hasExemplosAnySim)) {
        errors.PERGUNTA_20_EXEMPLOS = required(values?.PERGUNTA_20_EXEMPLOS)
      }
    }

    return errors
  }
)
